import { TenantName } from '@packlink/packlink-sdk';

const getBulkTenantName = () => {
  var _window;
  const hostname = ((_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname) || '';
  if (hostname.includes('pro')) {
    if (hostname.includes('.es') || hostname.includes('es-')) {
      return TenantName.PACKLINKPROES;
    }
    if (hostname.includes('.fr') || hostname.includes('fr-')) {
      return TenantName.PACKLINKPROFR;
    }
    if (hostname.includes('.it') || hostname.includes('it-')) {
      return TenantName.PACKLINKPROIT;
    }
    if (hostname.includes('.de') || hostname.includes('de-')) {
      return TenantName.PACKLINKPRODE;
    }
    if (hostname.includes('.com') || hostname.includes('packlinkpro-')) {
      return TenantName.PACKLINKPRO;
    }
  }
  if (hostname.includes('ebay')) {
    if (hostname.includes('.co.uk') || hostname.includes('uk-')) {
      return TenantName.EBAYGB;
    }
    if (hostname.includes('.es') || hostname.includes('es-')) {
      return TenantName.EBAYES;
    }
    if (hostname.includes('.fr') || hostname.includes('fr-')) {
      return TenantName.EBAYFR;
    }
    if (hostname.includes('.it') || hostname.includes('it-')) {
      return TenantName.EBAYIT;
    }
    if (hostname.includes('.ie') || hostname.includes('ie-')) {
      return TenantName.EBAYIE;
    }
    if (hostname.includes('.de') || hostname.includes('de-')) {
      return TenantName.EBAYDE;
    }
    if (hostname.includes('.at') || hostname.includes('at-')) {
      return TenantName.EBAYAT;
    }
    if (hostname.includes('.be') || hostname.includes('be-')) {
      return TenantName.EBAYBE;
    }
    if (hostname.includes('.nl') || hostname.includes('nl-')) {
      return TenantName.EBAYNL;
    }
  }
  if (hostname.includes('dpd')) {
    return TenantName.DPDBBEUN;
  }
  if (hostname.includes('correos')) {
    return TenantName.CORREOSES;
  }
  if (hostname.includes('paypal')) {
    var _window2;
    const pathname = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.location.pathname) || '';
    const basePath = pathname === null || pathname === void 0 ? void 0 : pathname.replace(/^\/|\/$/g, '').split('/')[0];
    if (basePath === 'es') {
      return TenantName.PAYPALES;
    }
    if (basePath === 'fr') {
      return TenantName.PAYPALFR;
    }
    if (basePath === 'it') {
      return TenantName.PAYPALIT;
    }
    if (basePath === 'pt') {
      return TenantName.PAYPALPT;
    }
    if (basePath === 'de') {
      return TenantName.PAYPALDE;
    }
    if (basePath === 'ie') {
      return TenantName.PAYPALIE;
    }
    if (basePath === 'at') {
      return TenantName.PAYPALAT;
    }
    if (basePath === 'nl') {
      return TenantName.PAYPALNL;
    }
    if (basePath === 'be') {
      return TenantName.PAYPALBE;
    }
    if (basePath === 'gb') {
      return TenantName.PAYPALGB;
    }
  }
  return null;
};

export { getBulkTenantName };
//# sourceMappingURL=bulk.js.map
